import library from './pralinLayers.json';

export function pralinLayerScene({front, back, ribbonFabric, view = 'front'}) {
  if (!['front', 'back'].includes(view)) return null;
  const bodyId = view === 'back' ? back?.option_id || library.defaultBack
    : front?.option_id || library.defaultFront;
  const ribbonId = ribbonFabric?.option_id || library.defaultRibbon;
  const body = library[view][bodyId], ribbon = library.ribbons[ribbonId];
  if (!body?.src || !ribbon?.src) return null;
  return {body:body.src, ribbon:ribbon.src, bodyId, ribbonId,
    bodyPlacement:body.placement,
    ribbonPlacement:{...library.ribbonPlacement, ...body.ribbonPlacement, ...ribbon.placement}};
}
